import React, { useState } from "react";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";
import { ContentCard, Button } from "../common";
import { grid } from "styled-components-grid";
// import { motion } from "framer-motion";
import { useLocation } from "@reach/router";

const Flex = styled.div`
  ${grid({})}
  justify-content: space-evenly;
  margin: 10px 0;

  &:hover > * > * {
    filter: grayscale(40%);
  }
  & > * > *:hover {
    filter: grayscale(0%);
  }
  & > * > * {
    transition: filter 150ms linear 100ms, transform 150ms ease-in-out 100ms;
  }
  > a {
    ${grid.unit({ size: { xs: 1 / 1, sm: 1 / 2, md: 1 / 2, lg: 1 / 4 } })}
  }
`;

// const Child = styled(motion.div)`
//   ${grid.unit({ size: { sm: 1 / 1, md: 1 / 2, lg: 1 / 4 } })}
//   padding: 0 10px;
// `;

// const SingleTale: React.FC = ({ item }) => {
//   return (
//     <Child
//       initial={{ opacity: 0, scale: 0 }}
//       animate={{ opacity: 1, scale: 1 }}
//       transition={{ ease: "easeOut", duration: 0.4 }}
//     >
//       <ContentCard
//         title={item.node.frontmatter.title}
//         link={item.node.frontmatter.slug}
//         image={item.node.frontmatter.hero || ""}
//       />
//     </Child>
//   );
// };

const Tales: React.FC<Props> = ({ ...props }) => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(filter: { fileAbsolutePath: { regex: "/(tales-mdx)/" } }, sort: {fields: frontmatter___date, order: DESC}) {
        edges {
          node {
            id
            frontmatter {
              title
              slug
              hero
            }
          }
        }
      }
    }
  `);

  const path = useLocation().pathname;
  if (path) {
    const thisPage = data.allMdx.edges.findIndex((item: unknown) => {
      return item.node.frontmatter.slug === path;
    });
    if (thisPage !== -1) {
      data.allMdx.edges.splice(thisPage, 1);
    }
  }

  const startingsShow = props.show || 4;
  const [show, setShow] = useState(startingsShow);
  const startingList = data.allMdx.edges.slice(0, show);
  const [list, setList] = useState(startingList);

  const loadMore = () => {
    // setShow and setList are async apparently, so to avoid delayed loading (2 clicks needed instead of one) we should do this workaround ...
    // Also, pagination has been updated to the initial dusplay length
    const newShow = show + startingsShow;
    setShow(newShow);
    setList(data.allMdx.edges.slice(0, newShow));
  };

  const showBtn =
    list.length < data.allMdx.edges.length && list.length < props.maxShow
      ? "block"
      : "none";

  const moreButton = <Button
      margin="25px auto"
      onClick={loadMore}
      style={{ display: showBtn }}
    >
      More insights
    </Button>;

  return (
    <>
      <Flex>
        {list.map((item: unknown, i: number) => {
          return (
            <ContentCard
              key={`${item.node.id}${i}`} 
              title={item.node.frontmatter.title}
              link={item.node.frontmatter.slug}
              image={item.node.frontmatter.hero || ""}
            />
          );
        })}
      </Flex>
      {(data.allMdx.edges.length > list.length && moreButton)}
    </>
  );
};

const TalesList = React.memo(Tales);

export { TalesList };

export interface Props {
  maxShow?: number;
  show?: number;
}
